// A saved default signature enables one-tap approve (core-features 3 UX).
// Kept per browser; never synced.
const KEY = "pm.signature";
export interface SavedSignature { name: string; data: string }

export function loadSignature(): SavedSignature | null {
  try {
    const raw = localStorage.getItem(KEY);
    const v = raw ? (JSON.parse(raw) as SavedSignature) : null;
    return v?.data?.startsWith("data:image") && v.name ? v : null;
  } catch {
    return null;
  }
}
export function saveSignature(s: SavedSignature | null) {
  try {
    if (s) localStorage.setItem(KEY, JSON.stringify(s)); else localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable: one-tap approve just stays off */
  }
}
